import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyAcUOqAolYns5aR_ON1UC09f3HG4v_I2Vo',
  authDomain: 'hub-project-49489.firebaseapp.com',
  databaseURL: 'https://hub-project-49489.firebaseio.com',
  projectId: 'hub-project-49489',
  storageBucket: 'hub-project-49489.appspot.com',
  messagingSenderId: '401850798009',
  appId: '1:401850798009:web:bbd9d923c92c876b',
};

// Get a firebase instance
export const db = firebase
  .initializeApp(firebaseConfig)
  .firestore();

// db.collection('jobs').add({ title: 'test' })
//   .then((docRef) => {
//     console.log('Document written with ID: ', docRef.id);
//     // commit('addJob', docRef);
//   })
//   .catch((error) => {
//     console.error('Error adding document: ', error);
//   });

// db.collection('jobs').get().then((querySnapshot) => {
//   querySnapshot.forEach((doc) => {
//     console.log(`${doc.id} => ${doc.data()}`);
//   });
// });

// Export types that exist in Firestore
// This is not alwayds necessary, but it's used in other examples
const { TimeStamp, GeoPoint } = firebase.firestore;
export { TimeStamp, GeoPoint };
